app
  .controller("HeaderCarouselController", [
    "$scope",
    "getSiteDetails",
    function ($scope, getSiteDetails) {
      if ($scope.payload) {
        getSiteDetails
          .getPlaylistContent($scope.payload.playlistID)
          .then((result) => {
            $scope.heroLivePlaylist = result.content[0].playlistContent;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  ])
  .directive("headerCarousel", function () {
    return {
      restrict: "AE",
      transclude: true,
      scope: {
        payload: "=payload",
      },
      templateUrl: "template/elements/heroCarousel.html",
    };
  });
